import { PaysafeCustomerDetails } from './paysafe-customer-details.interface';
import { PaysafePaymentType } from './paysafe-payment-type.enum';
import { PaysafeTransactionType } from './paysafe-transaction-type.enum';

export interface PaysafeTokenizationOptions {
  amount: number;
  customerDetails: PaysafeCustomerDetails;
  merchantRefNum: string;
  paymentType: PaysafePaymentType;
  transactionType: PaysafeTransactionType;
}
